import type { TaskBoardCounts, TaskRecord, TaskSettings } from "../pages/home/tasks/tasksTypes";
import { authorizedApiClient } from "./config";

export const getTaskBoardCounts = async (params: {
  workspace_id: string;
}) => {
  const response = await authorizedApiClient.get<TaskBoardCounts>(
    `/${params.workspace_id}/tasks/board-counts`,
  );
  return response.data;
};

export const updateTask = async (params: {
  workspace_id: string;
  task_external_id: string;
  updates: Partial<TaskRecord>;
}) => {
  const response = await authorizedApiClient.patch<TaskRecord>(
    `/${params.workspace_id}/tasks/${params.task_external_id}`,
    params.updates,
  );
  return response.data;
};

export const getTaskSettings = async (params: {
  workspace_id: string;
  workspace_member_id?: string;
}) => {
  const response = await authorizedApiClient.get<TaskSettings>(
    `/${params.workspace_id}/tasks/settings`,
    {
      params: params.workspace_member_id
        ? { workspace_member_id: params.workspace_member_id }
        : undefined,
    },
  );
  return response.data;
};

export const getTaskFilterPreview = async (params: {
  workspace_id: string;
  account_filters: Record<string, any>;
}): Promise<{ matching_accounts: number }> => {
  const response = await authorizedApiClient.post<{ matching_accounts: number }>(
    `/${params.workspace_id}/tasks/settings/filter-preview`,
    { account_filters: params.account_filters },
  );
  return response.data;
};

export const updateTaskSettings = async (params: {
  workspace_id: string;
  settings: Partial<TaskSettings>;
  workspace_member_id?: string;
}) => {
  const response = await authorizedApiClient.put<TaskSettings>(
    `/${params.workspace_id}/tasks/settings`,
    {
      ...params.settings,
      ...(params.workspace_member_id
        ? { workspace_member_id: params.workspace_member_id }
        : {}),
    },
  );
  return response.data;
};
